import { createEvent, createStore } from 'effector';
import { $resetAuth } from './profile-entity';

export interface IFeatures {
	builderEnabled: boolean;
}

export const $setFeatures = createEvent<IFeatures>();
export const $updateFeatures = createEvent<Partial<IFeatures>>();

export const $features = createStore<IFeatures>({ builderEnabled: true })
	.on($setFeatures, (_, payload) => payload)
	.on($updateFeatures, (state, payload) => ({ ...state, ...payload }))
	.reset($resetAuth);
